import { defineComponent } from "vue";

const heartLimProp = {
  color: { Type: String, default: "#000000" },
  defaultColor: { Type: String, default: "#ffffff" },
}

export const  heart = defineComponent({
  name: 'heart',
  setup(props) {
    return () => {
      return (
        <svg viewBox="0 0 1024 1024" width="200" xmlns="http://www.w3.org/2000/svg">
          <path  fill="currentColor" stroke-width="7" d="M502.64519202218054,204.42177777141214 C708.3804600743439,-290.86683132034346 1514.4579857213062,204.42177777141214 502.64519202218054,841.221418032255 C-509.1676016769345,204.42177777141214 296.9099239700281,-290.86683132034346 502.64519202218054,204.42177777141214 z" stroke="#000"></path>
        </svg>
      )
    }
  }
})



export const  heart10 = defineComponent({
  name: 'heart10',
  setup(props) {
    return () => {
      return (
        <svg viewBox="0 0 1024 1024" width="200" xmlns="http://www.w3.org/2000/svg">
          <path  fill="#999999" stroke-width="7" d="M502.64519202218054,204.42177777141214 C708.3804600743439,-290.86683132034346 1514.4579857213062,204.42177777141214 502.64519202218054,841.221418032255 C-509.1676016769345,204.42177777141214 296.9099239700281,-290.86683132034346 502.64519202218054,204.42177777141214 z" stroke="#000"></path>
          <path  fill="currentColor" stroke="#000" opacity="NaN" d="M100.42553,40.004420431137085 C100.42553,40.004420431137085 -8.14652,114.29056043113708 1.8535400000000002,241.43415043113708 C-19.57516,314.29171043113706 98.99695,491.4355804311371 98.99695,491.4355804311371 C98.99695,491.4355804311371 100.42553,40.004420431137085 100.42553,40.004420431137085 z" ></path>
        </svg>
      )
    }
  }
})

export const  heart20 = defineComponent({
  name: 'heart20',
  setup(props) {
    return () => {
      return (
        <svg viewBox="0 0 1024 1024" width="200" xmlns="http://www.w3.org/2000/svg">
          <path  fill="#999999" stroke-width="7" d="M502.64519202218054,204.42177777141214 C708.3804600743439,-290.86683132034346 1514.4579857213062,204.42177777141214 502.64519202218054,841.221418032255 C-509.1676016769345,204.42177777141214 296.9099239700281,-290.86683132034346 502.64519202218054,204.42177777141214 z" stroke="#000"></path>

          <path  fill="currentColor" d="M 197.5689303736713 5.718534987983798 C 197.5689303736713 5.718534987983798 -9.54769199380711 22.554065817851576 4.340844767129254 272.1666988910467 C 2.334955702917512 409.9703730569879 194.76852248360242 602.8647641500336 194.76852248360242 602.8647641500336 C 194.76852248360242 602.8647641500336 197.5689303736713 5.718534987983798 197.5689303736713 5.718534987983798 z" stroke="#000"></path>

        </svg>
      )
    }
  }
})
export const  heart30 = defineComponent({
  name: 'heart30',
  setup(props) {
    return () => {
      return (
        <svg viewBox="0 0 1024 1024" width="200" xmlns="http://www.w3.org/2000/svg">
          <path  fill="#999999" stroke-width="7" d="M502.64519202218054,204.42177777141214 C708.3804600743439,-290.86683132034346 1514.4579857213062,204.42177777141214 502.64519202218054,841.221418032255 C-509.1676016769345,204.42177777141214 296.9099239700281,-290.86683132034346 502.64519202218054,204.42177777141214 z" stroke="#000"></path>

          <path  fill="currentColor" d="M 300.426671119237 5.718534994543084 C 300.426671119237 5.718534994543084 -29.417831396357215 -63.35962884920186 4.6954751999707005 314.2374599474003 C 60.19727186303862 508.08551893431985 296.1407104536733 697.1510071197913 296.1407104536733 697.1510071197913 C 296.1407104536733 697.1510071197913 300.426671119237 5.718534994543084 300.426671119237 5.718534994543084 z" stroke="#000"></path>


        </svg>
      )
    }
  }
})
export const  heart40 = defineComponent({
  name: 'heart40',
  setup(props) {
    return () => {
      return (
        <svg viewBox="0 0 1024 1024" width="200" xmlns="http://www.w3.org/2000/svg">
          <path  fill="#999999" stroke-width="7" d="M502.64519202218054,204.42177777141214 C708.3804600743439,-290.86683132034346 1514.4579857213062,204.42177777141214 502.64519202218054,841.221418032255 C-509.1676016769345,204.42177777141214 296.9099239700281,-290.86683132034346 502.64519202218054,204.42177777141214 z" stroke="#000"></path>

          <path  fill="currentColor" d="M 401.8650772861072 61.71891543544763 C 401.8650772861072 61.71891543544763 353.29337029496617 3.1471511226012296 227.57836396495458 0.2899918878282507 C -10.994432138590469 24.5758453833987 3.2913640352745688 233.14846952182722 3.2913640352745688 233.14846952182722 C -16.708750608136427 488.86422103401003 403.29365690349357 777.4373037460825 403.29365690349357 777.4373037460825 C 403.29365690349357 777.4373037460825 401.8650772861072 61.71891543544763 401.8650772861072 61.71891543544763 z"></path>

        </svg>
      )
    }
  }
})
export const  heart50 = defineComponent({
  name: 'heart50',
  setup(props) {
    return () => {
      return (
        <svg viewBox="0 0 1024 1024" width="200" xmlns="http://www.w3.org/2000/svg">
          <path  fill="#999999" stroke-width="7" d="M502.64519202218054,204.42177777141214 C708.3804600743439,-290.86683132034346 1514.4579857213062,204.42177777141214 502.64519202218054,841.221418032255 C-509.1676016769345,204.42177777141214 296.9099239700281,-290.86683132034346 502.64519202218054,204.42177777141214 z" stroke="#000"></path>
          <path  fill="currentColor" d="M 500.86605347908426 202.0059718199389 C 500.86605347908426 202.0059718199389 436.5799706966919 -2.2809134663301336 223.72160770610384 2.004825385829349 C -7.708290310508687 24.8620992640133 -0.5653922235761686 249.14909919369336 -0.5653922235761686 249.14909919369336 C 46.57773515017823 590.579627749066 498.00889424431125 839.1524811743163 498.00889424431125 839.1524811743163 C 498.00889424431125 839.1524811743163 500.86605347908426 202.0059718199389 500.86605347908426 202.0059718199389 z"></path>
        </svg>
      )
    }
  }
})
export const  heart60 = defineComponent({
  name: 'heart60',
  setup(props) {
    return () => {
      return (
        <svg viewBox="0 0 1024 1024" width="200" xmlns="http://www.w3.org/2000/svg">
          <path  fill="#999999" stroke-width="7" d="M502.64519202218054,204.42177777141214 C708.3804600743439,-290.86683132034346 1514.4579857213062,204.42177777141214 502.64519202218054,841.221418032255 C-509.1676016769345,204.42177777141214 296.9099239700281,-290.86683132034346 502.64519202218054,204.42177777141214 z" stroke="#000"></path>

          <path  fill="currentColor"  stroke="#000" opacity="NaN" d="M 601.8482523958994 59.46254658996713 C 601.8482523958994 59.46254658996713 526.4635452511086 122.53954644581268 500.3096672620994 205.6165706461946 C 406.46339918389003 -22.076014199296644 217.23239961635346 2.53940037859428 217.23239961635346 2.53940037859428 C 217.23239961635346 2.53940037859428 6.462912293162162 16.38557107865799 1.8475220598076012 244.0781559241493 C -5.844794995783332 531.7708138032497 500.3096672620994 845.6173496713594 500.3096672620994 845.6173496713594 C 500.3096672620994 845.6173496713594 600.3097889847813 773.3095693488049 600.3097889847813 773.3095693488049 C 600.3097889847813 773.3095693488049 604.9251792181358 57.924083178848946 601.8482523958994 59.46254658996713 z"></path>
        </svg>
      )
    }
  }
})
export const  heart70 = defineComponent({
  name: 'heart70',
  setup(props) {
    return () => {
      return (
        <svg viewBox="0 0 1024 1024" width="200" xmlns="http://www.w3.org/2000/svg">
          <path  fill="#999999" stroke-width="7" d="M502.64519202218054,204.42177777141214 C708.3804600743439,-290.86683132034346 1514.4579857213062,204.42177777141214 502.64519202218054,841.221418032255 C-509.1676016769345,204.42177777141214 296.9099239700281,-290.86683132034346 502.64519202218054,204.42177777141214 z" stroke="#000"></path>

          <path  fill="currentColor"  opacity="NaN" d="M 701.8483741185814 10.231717434185214 C 686.4637400073996 -2.0759898547602873 532.6173988955813 84.07796116785806 500.3096672620994 205.6165706461946 C 406.46339918389003 -22.076014199296644 217.23239961635346 2.53940037859428 217.23239961635346 2.53940037859428 C 217.23239961635346 2.53940037859428 6.462912293162162 16.38557107865799 1.8475220598076012 244.0781559241493 C -5.844794995783332 531.7708138032497 500.3096672620994 845.6173496713594 500.3096672620994 845.6173496713594 C 500.3096672620994 845.6173496713594 684.9252765962815 725.6172036041407 700.3099107074634 696.3863987928955 C 697.232983885227 701.0017890262501 698.7714472963448 8.69325402306697 701.8483741185814 10.231717434185214 z" stroke="#000"></path>
        </svg>
      )
    }
  }
})
export const  heart80 = defineComponent({
  name: 'heart80',
  setup(props) {
    return () => {
      return (
        <svg viewBox="0 0 1024 1024" width="200" xmlns="http://www.w3.org/2000/svg">
          <path  fill="#999999" stroke-width="7" d="M502.64519202218054,204.42177777141214 C708.3804600743439,-290.86683132034346 1514.4579857213062,204.42177777141214 502.64519202218054,841.221418032255 C-509.1676016769345,204.42177777141214 296.9099239700281,-290.86683132034346 502.64519202218054,204.42177777141214 z" stroke="#000"></path>

          <path  fill="currentColor"  opacity="NaN" d="M 800.3100324301453 1.0009369674760935 C 666.463715662863 -18.999087377060285 552.6174232401177 70.23179046779438 500.3096672620994 205.6165706461946 C 406.46339918389003 -22.076014199296644 217.23239961635346 2.53940037859428 217.23239961635346 2.53940037859428 C 217.23239961635346 2.53940037859428 6.462912293162162 16.38557107865799 1.8475220598076012 244.0781559241493 C -5.844794995783332 531.7708138032497 500.3096672620994 845.6173496713594 500.3096672620994 845.6173496713594 C 500.3096672620994 845.6173496713594 775.6946178522544 651.7709598704678 800.3100324301453 607.1555209480407 C 798.7715690190271 607.1555209480408 797.2331056079087 1.0009369674760524 800.3100324301453 1.0009369674760935 z" stroke="#000"></path>
        </svg>
      )
    }
  }
})
export const  heart90 = defineComponent({
  name: 'heart90',
  setup(props) {
    return () => {
      return (
        <svg viewBox="0 0 1024 1024" width="200" xmlns="http://www.w3.org/2000/svg">
          <path  fill="#999999" stroke-width="7" d="M502.64519202218054,204.42177777141214 C708.3804600743439,-290.86683132034346 1514.4579857213062,204.42177777141214 502.64519202218054,841.221418032255 C-509.1676016769345,204.42177777141214 296.9099239700281,-290.86683132034346 502.64519202218054,204.42177777141214 z" stroke="#000"></path>

          <path  fill="currentColor"  opacity="NaN" d="M 900.3101541528274 37.92405883431252 C 704.9253009408177 -66.69145312172401 552.6174232401177 70.23179046779438 500.3096672620994 205.6165706461946 C 406.46339918389003 -22.076014199296644 217.23239961635346 2.53940037859428 217.23239961635346 2.53940037859428 C 217.23239961635346 2.53940037859428 6.462912293162162 16.38557107865799 1.8475220598076012 244.0781559241493 C -5.844794995783332 531.7708138032497 500.3096672620994 845.6173496713594 500.3096672620994 845.6173496713594 C 500.3096672620994 845.6173496713594 846.4639347636909 611.7709111813949 903.3870809750637 491.77076511417687 C 900.3101541528275 496.38615534753166 900.3101541528272 34.8471320120761 900.3101541528274 37.92405883431252 z" stroke="#000"></path>
        </svg>
      )
    }
  }
})
export const  heartFilled = defineComponent({
  name: 'heart-filled',
  setup(props) {
    return () => {
      return (
        <svg viewBox="0 0 1024 1024" width="200" xmlns="http://www.w3.org/2000/svg">
          <path  fill="currentColor" stroke-width="7" d="M502.64519,204.42178C708.38046,-290.86683 1514.45798,204.42178 502.64519,841.22142C-509.1676,204.42178 296.90992,-290.86683 502.64519,204.42178z"></path>
        </svg>
      )
    }
  }
})
